const data = {
  id: 0,
  curation: require("./0/curation").default,
};

export default data;
